import { crabDevice, sleep } from '@hfzq/crab-utils';
import { getCommonConfig } from '@src/apis/zz-api/get-common-config';

interface initSensorsOptions {
  show_log?: boolean;
  auto_track?: boolean;
  is_track_single_page?: boolean;
  use_client_time?: boolean;
  app_js_bridge?: boolean | { white_list: string[] };
  [key: string]: unknown;
}

/**
 * 神策sdk初始化
 *
 * 异步加载神策sdk，不影响页面的加载速度
 */
export async function initSensors({
  show_log = false,
  is_track_single_page = false,
  use_client_time = true,
  app_js_bridge = {
    white_list: [
      'https://sensorsdata-test.hfzq.com.cn:8106/sa?project=production',
      'https://sensorsdata.hfzq.com.cn/sa?project=xiaofuniu',
      'https://bigdata.cib.com.cn/sa?project=xiaofuniu',
      'https://bigdata.cib.com.cn/sa?project=default',
    ],
  },
  ...options
}: initSensorsOptions) {
  if (process.env.NODE_ENV === 'production' && !crabDevice.isTZT) {
    return;
  }
  (function (para: { name: string }) {
    const n = para.name;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const w = window as any;
    if (typeof w.sensorsDataAnalytic201505 !== 'undefined') {
      return false;
    }
    w.sensorsDataAnalytic201505 = n;
    w[n] =
      w[n] ||
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      function (a: any) {
        return function () {
          // eslint-disable-next-line no-underscore-dangle, prefer-rest-params
          (w[n]._q = w[n]._q || []).push([a, arguments]);
        };
      };
    const ifs = [
      'track',
      'quick',
      'register',
      'registerPage',
      'registerOnce',
      'clearAllRegister',
      'trackSignup',
      'trackAbtest',
      'setProfile',
      'setOnceProfile',
      'appendProfile',
      'incrementProfile',
      'deleteProfile',
      'unsetProfile',
      'identify',
      'login',
      'logout',
      'trackLink',
      'clearAllRegister',
    ];
    for (let i = 0; i < ifs.length; i += 1) {
      w[n][ifs[i]] = w[n].call(null, ifs[i]);
    }
  })({
    name: 'sensors',
  });
  const { SHENCELINK } = await getCommonConfig();
  if (SHENCELINK) {
    window.sensors.para = {
      server_url: SHENCELINK,
      show_log,
      is_track_single_page,
      use_client_time,
      app_js_bridge,
      ...options,
    };
    await sleep(3000);
    // 异步导入神策sdk， 不影响页面加载速度
    await import('sa-sdk-javascript');
  }
}

/**
 *  神策数据上报
 *
 * @param event 事件名
 * @param params 事件参数
 */
export function sensorsTrack<T extends Record<string, unknown>>(event: string, params: T) {
  window.sensors.track(event, params);
}
